import React, { useCallback, useMemo, useState } from "react";

function TGUIRoute({ route }) {
  const [useLargeFont, setUseLargeFont] = useState(false);

  const [pathString, viewBox] = useMemo(() => {
    let minX = 180;
    let maxX = -180;
    let minY = 90;
    let maxY = -90;  
    const pointsString = route.map(waypoint => {
      const x = waypoint.position.longitude;
      const y = -waypoint.position.latitude;
      if (x < minX) {
        minX = x;
      }
      if (x > maxX) {
        maxX = x;
      }
      if (y < minY) {
        minY = y;
      }
      if (y > maxY) {
        maxY = y;
      }
      return `${x} ${y}`;
    }).join(", ");
    const xRange = maxX - minX;
    const xMargin = 0.5;
    const yRange = maxY - minY;
    const yMargin = 0.5;
    const width = xRange + xMargin * 2;
    const height = yRange + yMargin * 2;
    return [
      `M ${pointsString}`,
      `${minX - xMargin} ${minY - yMargin} ${width} ${height}`
    ];
  }, [route]);

  const handleTguiRouteClick = useCallback(() => {
    setUseLargeFont(!useLargeFont);
  }, [useLargeFont]);

  if (!route.length) {
    return null;
  }

  return (
    <div
      className="tgui-path"
      onClick={handleTguiRouteClick}
    >
      <svg viewBox={viewBox}>
        <path
          d={pathString}
          fill="transparent"
          stroke="#444"
          vectorEffect="non-scaling-stroke"
          strokeWidth={1}
        />
        {route.map((waypoint, i) => {
          const x = waypoint.position.longitude;
          const y = -waypoint.position.latitude;
          return (
            <>
              <text
                x={x}
                y={y}
                fill="#999"
                textAnchor={i % 2 === 0 ? "end" : "start"}
                alignmentBaseline={i % 2 === 0 ? "bottom" : "hanging"}
                fontSize={useLargeFont ? 0.15 : 0.075}
                className="label"
              >
                {waypoint.identifier}
              </text>
              <rect x={x - 0.01} y={y - 0.01} width={0.02} height={0.02} fill="#999" />
            </>
          );
        })}
      </svg>
    </div>
  );
}

export default TGUIRoute;